import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';

@Component({
  selector: 'app-dlr-help-docs',
  templateUrl: './dlr-help-docs.component.html',
  styleUrls: ['./dlr-help-docs.component.scss'],
  standalone: true,
  imports:[
    CommonModule,
    MatTabsModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule
  ]
})
export class DlrHelpDocsComponent implements OnInit {
  selectedIndex = 0;

  constructor() {}

  ngOnInit(): void {
    // Check if there's a stored tab index
    const storedIndex = localStorage.getItem('dlr-help-docs-tab');
    if (storedIndex) {
      this.selectedIndex = parseInt(storedIndex, 10);
    }
  }

  onTabChange(index: number): void {
    this.selectedIndex = index;
    // Store the selected tab index
    localStorage.setItem('dlr-help-docs-tab', index.toString());
  }
}
